import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { TableRow, TableCell } from '@material-ui/core';

const useStyles = makeStyles({
  row: {
    height: '40px',
  },
});

const LinhaVaziaTabelaGerenciarMembros = () => {
  const classes = useStyles();

  const tableCell = () => {
    const colunas = [];
    let index = 0;

    for (let i = 0; i < 1; i++) {
      colunas.push(<TableCell key={index++} />);
    }

    return colunas;
  };

  return (
    <TableRow
      data-testid="linha-vazia-tabela-gerenciar-membros"
      className={classes.row}
    >
      {tableCell()}
    </TableRow>
  );
};

export default LinhaVaziaTabelaGerenciarMembros;
